import styles from "./DetailPane.module.scss";
import {Card} from "@mbkit/card";

function DetailPane(props) {
    return (
        <Card className={styles.detailPane}>{props.children}</Card>
    );
}

export default DetailPane;